module.exports = __webpack_public_path__ + "img/pluto41.0348aa08.jpg";